module.exports = __webpack_public_path__ + "img/mtn-mm-logo-generic-mtn-mobile-money-logo.a75f899c.svg";